var React = require('react');

function E1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"E1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"49.62 51.12 50.1 30.33 23.6 29.73 16.17 50.36 49.62 51.12","fill":"#73c9bd","key":0}),React.createElement("polygon",{"points":"23.48 21.31 49.47 20.79 49.05 0 23.07 0.52 0 0.98 1.19 60.21 1.6 81 24.67 80.54 50.66 80.02 50.24 59.23 32.65 59.58 24.25 59.75 23.48 21.31","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

E1.defaultProps = {"viewBox":"0 0 50.65 81"};

module.exports = E1;

E1.default = E1;
